import { FC, memo } from 'react'
import type { Props } from '../../types'
import themes from 'styles/themes'

const InactiveTiktok: FC<Props> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M5.65952 8.04696C4.42387 8.04696 3.42561 9.04522 3.44387 10.2687C3.45604 11.0539 3.88822 11.7357 4.52431 12.1161C4.30822 11.7843 4.18039 11.3917 4.17431 10.9687C4.15604 9.74522 5.15431 8.74696 6.38996 8.74696C6.63344 8.74696 6.86778 8.78652 7.08691 8.85652V6.40652C6.85865 6.37304 6.62431 6.35478 6.38996 6.35478C6.37778 6.35478 6.36865 6.35478 6.35648 6.35478V8.15652C6.13735 8.08652 5.903 8.04696 5.65952 8.04696Z"
      fill={themes.light.colours.gray[5]}
    />
    <path
      d="M11.0008 0.7H10.3495C10.5321 1.61609 11.0465 2.41348 11.7647 2.95522C11.293 2.3313 11.0069 1.55217 11.0008 0.7Z"
      fill={themes.light.colours.gray[5]}
    />
    <path
      d="M14.726 4.42826C14.4856 4.42826 14.2543 4.40391 14.026 4.3613L10.2826 4.84217L6.35648 14.767C6.12822 14.8004 5.89387 14.8187 5.65952 14.8187C4.61865 14.8187 3.62648 14.4809 2.81996 13.857C2.91126 13.9665 3.00865 14.073 3.11518 14.1765C3.9917 15.0409 5.15431 15.5187 6.393 15.5187C6.62735 15.5187 6.8617 15.5004 7.08996 15.467C8.06387 15.3239 8.9617 14.8765 9.67083 14.1765C10.5413 13.3152 11.0221 12.1739 11.0282 10.9565L10.9826 5.54217C11.3965 5.86174 11.85 6.12956 12.34 6.33348C13.0978 6.65304 13.9013 6.81739 14.726 6.81739"
      fill={themes.light.colours.gray[5]}
    />
    <path
      d="M3.10605 7.70305C3.97344 6.84174 5.12691 6.36391 6.35648 6.35478V5.70652C6.12822 5.67305 5.89387 5.65479 5.65952 5.65479C4.41778 5.65479 3.25213 6.13261 2.37561 7.00305C1.51431 7.85826 1.02126 9.02696 1.02431 10.2413C1.02431 11.4648 1.50822 12.6122 2.3817 13.4796C2.5217 13.6165 2.66474 13.7444 2.81691 13.86C2.12909 13.0413 1.75474 12.0187 1.7517 10.9413C1.75474 9.72696 2.24474 8.55826 3.10605 7.70305Z"
      fill={themes.light.colours.gray[5]}
    />
    <path
      d="M14.026 4.3613L14.0261 3.71001H14.02C13.1739 3.71001 12.3948 3.43001 11.7678 2.95523C12.3126 3.67349 13.11 4.18478 14.026 4.3613Z"
      fill={themes.light.colours.gray[5]}
    />
    <path
      d="M6.26516 13.1235C6.55429 13.1387 6.83125 13.0991 7.0869 13.017C7.96951 12.7278 8.6056 11.9061 8.6056 10.9383L8.60864 0.7H10.3495C10.3039 0.471739 10.2795 0.240435 10.2765 0H7.87821L7.87516 10.2352C7.87516 11.203 7.23907 12.0248 6.35647 12.3139C6.10081 12.3991 5.82386 12.4387 5.53473 12.4204C5.16647 12.3991 4.82255 12.2896 4.52429 12.113C4.89864 12.6913 5.53777 13.0839 6.26516 13.1235Z"
      fill={themes.light.colours.gray[5]}
    />
    <path
      d="M6.35648 14.767C7.33039 14.6239 8.22825 14.1765 8.93738 13.4765C9.80782 12.6152 10.2887 11.4739 10.2948 10.2565L10.2826 4.84217C10.6965 5.16174 11.15 5.42958 11.64 5.63349C12.3978 5.95306 13.2013 6.1174 14.0261 6.1174L14.026 4.3613C13.11 4.18478 12.3126 3.67349 11.7678 2.95523C11.0496 2.41349 10.5322 1.6161 10.3526 0.700012L8.60864 0.7L8.60564 10.9352C8.60564 11.9031 7.96956 12.7248 7.08695 13.0139C6.8313 13.0991 6.55434 13.1387 6.26521 13.1204C5.53477 13.0809 4.89864 12.6883 4.52429 12.113C3.88821 11.7357 3.45608 11.0509 3.44391 10.2657C3.42564 9.04219 4.42391 8.04393 5.65956 8.04393C5.90304 8.04393 6.13738 8.08349 6.35651 8.15349V6.35175C5.12695 6.36088 3.97347 6.83871 3.10608 7.70001C2.24477 8.55523 1.75173 9.72392 1.75477 10.9352C1.75477 12.0126 2.12912 13.0352 2.81999 13.8539C3.62956 14.4778 4.61869 14.8157 5.65956 14.8157C5.89391 14.8187 6.12822 14.8004 6.35648 14.767Z"
      fill={themes.light.colours.gray[5]}
    />
  </svg>
)

export default memo(InactiveTiktok)
